import {useEffect} from 'react'

import CommentGroup from '../../Details/Timeline/CommentGroup.js'
import {useSelector} from '../../../../store.js'

/**
 * A popover for comments in a list
 *
 * @param {Object} props
 * @param {String} props.title
 * @param {Function} props.commentGroupsSelector
 * @param {Function} props.ensureComments
 * @returns {React.ReactNode}
 */
export default function Popover({
  title,
  commentGroupsSelector,
  ensureComments,
}) {
  const commentGroups = useSelector(commentGroupsSelector)

  useEffect(() => {
    ensureComments()
  }, [])

  return (
    <dl className="pop-over--zropdown pop-over--w-35vw">
      <dt className="pop-over__title">{title}</dt>
      <dd className="pop-over__body">
        {commentGroups.length === 0 && (
          <div className="loading align-center margin-top-30 margin-bottom-30">
            <span className="spinner--md v-align-middle" />
            <em className="inline-block v-align-middle fs-00 op-75 margin-left-5">
              Loading timeline...
            </em>
          </div>
        )}
        {commentGroups.map(({day, comments}) => (
          <CommentGroup key={day} day={day} comments={comments} />
        ))}
      </dd>
    </dl>
  )
}
